export default __webpack_public_path__ + "static/media/add_user.611d4da5.svg";